import React from 'react'
import "./teamUserSecurity.scss"

//Imagens:
import ImgTeamUserSecurity from "../../../assets/securityAndManagement/teamUserSecurity.png"
import SectionComponent from '../../../components/utils/SectionComponent'
import { useTranslation } from 'react-i18next'

function TeamUserSecurity() {

  const { t } = useTranslation()

  return (
    <div className='container-team-user-security'>
      <div className='img-team-user-security'>
        <img src={ImgTeamUserSecurity} alt="" />
      </div>
      <div className='texts-team-user-security'>
        <SectionComponent title={t("user_security_and_management.user_secrty.title")} text={t("user_security_and_management.user_secrty.section_text")} />
        <SectionComponent title={t("user_security_and_management.team_secrty.title")} text={t("user_security_and_management.team_secrty.section_text")} />
        <SectionComponent title={t("user_security_and_management.user_params.title")} text={t("user_security_and_management.user_params.section_text")} />
      </div>
    </div>
  )
}

export default TeamUserSecurity